import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';

import styles from "../../assets/containers/blockCard.module.css";
import { BooksIcon } from "../../assets/icons/Books.js";
import { ArrowRightIcon } from "../../assets/icons/ArrowRight.js";
import { ReviewIcon } from "../../assets/icons/ReviewIcon.js";
import {useAppGlobalConfig} from "../../providers/AppGlobalConfigContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { getUserId } from "../../helpers/user";
import { getCompleteness, getUsage } from "../../service/service";
import { getCompletenessWithFallback } from "../../helpers/progressFallback";
import DefaultBatchImage from "../../assets/images/default_batch_image.svg"
import { t } from "../../lib/i18n";
const BlockCard = props => {

  const {isEmbedMode, fireNavigationEvents} = useAppGlobalConfig();

  const { lessons, validIndex, groupIndex, batch } = props;

  const [tenant, setTenant] = useState();
  const [isComplete, setIsComplete] = useState(false);
  const { setBatchData } = useAppGlobalConfig();

  useEffect(() => {
    isEmbedMode ? setTenant("cupheadless") : setTenant("cupfranchise")
    localStorage.removeItem('lessons');
  }, []);

  useEffect(() => {
    isEmbedMode ? setTenant("cupheadless") : setTenant("cupfranchise")
  }, [isEmbedMode]);

  useEffect(() => {
    if (batch.id && tenant) {
      checkCompleteness();
      setBatchData(batch);
    }
  }, [batch, tenant]);

  const getLessonNumber = (name) => {
    const match = name.match(/\d+/);
    return match ? match[0] : null;
  }

  const isSpecialLesson = (name) => {
    return name && (name.toLowerCase() === 'welcome lesson'
      || name.toLowerCase() === 'useful language'
      || name.toLowerCase() === 'clase cero');
  };

  const isLesson = (name) => {
    return name && (name.toLowerCase().startsWith('lesson')
      || name.toLowerCase().startsWith('lección'));
  };

  const isReview = (name) => {
    return name && (name.toLowerCase().includes('review')
      || name.toLowerCase().includes('revisión'));
  };

  const getLastLesson = (lessons) => {
    for (let i = lessons.length - 1; i >= 0; i--) {
      const lesson = lessons[i];
      if (isLesson(lesson.name)) {
        return lesson;
      }
    }
    return null;
  };

  const getFirstLesson = (lessons) => {
    for (let i = 0; i < lessons.length; i++) {
      const lesson = lessons[i];
      if (isLesson(lesson.name)) {
        return lesson;
      }
    }
    return null;
  };

  const getReviewLesson = (lessons) => {
    return lessons.find(lesson => isReview(lesson.name));
  };

  const getSpecialLessons = (lessons) => {
    return lessons.filter(lesson => isSpecialLesson(lesson.name));
  };

  const checkCompleteness = async () => {
    const userId = await getUserId();
    try {
      getCompletenessWithFallback(userId, batch.id, tenant)
          .then((completeness) => {
            // If the length of the `completedLessons` property equals the `totalLessonsInBatch` property, it means
            // the user has done all the lessons inside that batch, thus completing the batch.
            setIsComplete(completeness.data.completedLessons.length >= completeness.data.totalLessonsInBatch); //check if complete 
          });
    } catch (err) {
      console.log("Error getting batch completeness ", batch.id, ":", err.message);
      setIsComplete(false);
    }
  }

  const getBatchTitle = () => {
    return batch.title ? batch.title : `Batch: ${validIndex}`;
  }

  const getBatchImage = () => {
    const sourcePath = process.env.REACT_APP_CLOUDFRONT_DNS;
    return batch.image ? `${sourcePath}/media/images/${batch.image}` : DefaultBatchImage;
  }

  const firstLesson = getFirstLesson(lessons)
  const lastLesson = getLastLesson(lessons);
  const reviewLesson = getReviewLesson(lessons);
  const specialLessons = getSpecialLessons(lessons);
  const lessonAmount = firstLesson && firstLesson.name.toLowerCase().startsWith('lección') ? lessons.length > 1 ? 'Lecciones' : 'lección'
    : lessons.length > 1 ? 'Lessons' : 'Lesson';
  return (
    <>
      <div key={groupIndex} className={styles["group-card"]}>
        <div className={styles["card-image-container"]}>
          <img
              src={getBatchImage()}
              alt="Batch Cover"
              className={styles["card-image"]}
          />
        </div>
        <div className={styles["card-content"]}>
          <h2 className={styles["card-title"]}>{getBatchTitle()}</h2>
          {specialLessons.length > 0 && (
            <div className={styles["card-special-container"]}>
              <div className={styles["card-lessons"]}>
                <div className={styles["card-special-lessons"]}>
                  {specialLessons.map((lesson, index) => (
                    <div key={index} className={styles["special-lesson"]}>
                      <BooksIcon className={styles["book-icon"]} /> {lesson.name}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
          <div>
            <div className={styles["card-lessons-container"]}>
              <div className={styles["card-lessons"]}>
                {firstLesson && lastLesson && (
                  <div className={styles["card-lessons"]}>
                    <BooksIcon className={styles["book-icon"]} /> {`${lessonAmount}`} <b> &nbsp;
                      {`${getLessonNumber(firstLesson.name) || firstLesson.name} to ${getLessonNumber(lastLesson.name)}`}</b>
                  </div>
                )}
              </div>
            </div>
            {reviewLesson && (
              <div className={styles["card-reviews-container"]}>
                <div className={styles["card-lessons"]}>
                  <ReviewIcon className={styles["review-icon"]} /> Review {getLessonNumber(reviewLesson.name)}
                </div>
              </div>
            )}
          </div>
          <Link
            to={{ pathname: `${isEmbedMode ? '/embeddable' : ''}/lessonsList`, lessons: lessons }}
            className={styles["card-link"]}
            onClick={() => {
              sessionStorage.setItem('last-accessed-lessons', JSON.stringify(lessons));
              localStorage.setItem('lessons', JSON.stringify(lessons));                            
              localStorage.setItem('blockName', `Batch: ${validIndex}`);
              localStorage.setItem('batch', JSON.stringify(batch));
            }}
          >
            {t("Start Now")} <ArrowRightIcon className={styles["arrow-icon"]} />
          </Link>
          <div className={styles["card-completeness"]}>
            {isComplete && (
              <>
                <FontAwesomeIcon icon={faCheckCircle} size={"sm"} className={styles["card-completeness-icon"]}/>
                <span className={styles["card-completeness-text"]}>{t("Completed")}</span>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BlockCard;
